import { __extends } from 'tslib';
import classNames from 'classnames';
import React__default, { PureComponent } from 'react';
import DivTooltip from '../DivTooltip/DivTooltip.js';
import TooltipBody from '../Tooltip/TooltipBody.js';
import styles from './SearchInput.module.scss.js';

var SearchInput = (function (_super) {
    __extends(SearchInput, _super);
    function SearchInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (event) {
            event.preventDefault();
            var trimmedValue = event.target.value.trim();
            _this.props.onChange(trimmedValue);
        };
        _this.onClearClick = function (event) {
            event.stopPropagation();
            _this.props.onClose();
            _this.props.onChange('');
        };
        _this.onKeyPress = function (e) {
            if (e.keyCode === 27) {
                _this.props.onClose();
                _this.props.onChange('');
            }
        };
        _this.onClick = function (event) {
            event.stopPropagation();
        };
        return _this;
    }
    SearchInput.prototype.render = function () {
        var _a;
        var _b;
        return (React__default.createElement("div", { className: classNames((_b = this.props) === null || _b === void 0 ? void 0 : _b.className, (_a = {},
                _a[styles.containerFullWidth] = this.props.isFullwidth,
                _a[styles.container] = !this.props.isFullwidth,
                _a)), onClick: this.onClick },
            React__default.createElement("input", { className: styles.input, maxLength: 100, placeholder: this.props.placeholder, spellCheck: false, type: "text", value: this.props.value, onChange: this.onChange, autoFocus: this.props.autoFocus, onKeyDownCapture: this.onKeyPress }),
            this.props.closeTooltip && this.props.closeTooltip.length ? (React__default.createElement(DivTooltip, { tooltipBody: React__default.createElement(TooltipBody, null, this.props.closeTooltip) },
                React__default.createElement("div", { className: styles.clear, onClick: this.onClearClick }))) : (React__default.createElement("div", { className: styles.clear, onClick: this.onClearClick }))));
    };
    return SearchInput;
}(PureComponent));

export { SearchInput as default };
//# sourceMappingURL=SearchInput.js.map
